<template>
  <div :class="['ten-date-time', { 'ten-date-time-range': isRange }]">
    <div
      v-show="showTime"
      class="ten-date-time__time"
    >
      <div class="ten-date-time__time-header">
        <div class="ten-date-time__time-header-date">
          {{ startDate }}
        </div>
        <div
          class="ten-date-time__time-header-date"
          v-if="isRange"
        >
          {{ endDate }}
        </div>
      </div>
      <component
        v-bind="$attrs"
        :is="isRange ? 'TimeRange' : 'Time'"
        :value="value"
        :disabledHour="disabledHour"
        :disabledMin="disabledMin"
        :disabledSec="disabledSec"
        @change="onChangeHandler"
      />
    </div>
    <div
      v-show="!showTime"
      class="ten-date-time__date"
    >
      <component
        v-bind="$attrs"
        :is="isRange ? 'DateRange' : 'DatePanel'"
        :value="value"
        @change="onChangeHandler"
      />
    </div>
    <div class="ten-date-time__footer">
      <ten-button
        class="ten-date-time__footer-btn"
        type="text"
        @click="onToggleBtn"
      >
        {{ showTime ? t('datePicker.selectDate') : t('datePicker.selectTime') }}
      </ten-button>
    </div>
  </div>
</template>

<script>
import DatePanel from './date';
import DateRange from './date-range';
import Time from './time';
import TimeRange from './time-range';
import Button from '../../button';
import { localMixin } from '../../config';

import { dateToFormat, getToday } from '../util';

const TODAY = getToday();

export default {
  provide() {
    return {
      dateTime: this,
    };
  },
  components: {
    DatePanel,
    DateRange,
    Time,
    TimeRange,
    TenButton: Button,
  },
  mixins: [localMixin],
  inheritAttrs: false,
  props: {
    value: [Array, Date],
    isRange: Boolean,
    disabledHour: Function,
    disabledMin: Function,
    disabledSec: Function,
  },
  data() {
    return {
      showTime: false,
    };
  },
  computed: {
    startDate() {
      return dateToFormat((this.isRange ? this.value[0] : this.value) || TODAY, 'YYYY 年 MM 月 DD 日');
    },
    endDate() {
      return dateToFormat(this.value[1] || TODAY, 'YYYY 年 MM 月 DD 日');
    },
  },
  methods: {
    onToggleBtn() {
      this.showTime = !this.showTime;
    },
    onChangeHandler(value) {
      this.$emit('change', value);
    },
  },
};
</script>
